import "../../new.scss";
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useContext, useEffect, useMemo } from "react";
import { InventariosCabFormContext } from '../../../context/inventariosCab/InventariosCabContext';
import { AuthContext } from '../../../context/AuthContext';
import { InventariosDetState } from '../../../context/inventariosDet/InventariosDetState';
import DatatableDetalle from './inventariosdet/DatatableDetalle';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import getInputs from './configForm/inputs';
import { handleInputChange } from "./helpersForm/formHandlers";
import CircularProgress from "@mui/material/CircularProgress";
import DepositosModal from "../../depositos/depositosModal/depositosModal";

export const Form = ({ title }) => {
  const {
    report,
    postInventarioCabData, // Asegúrate que estas funciones están bien definidas en tu contexto
    detalleInventarioData,
    addItemToArray,
    getItemFromArrayById,
    updateItemFromArray,
    removeItemFromArray,
    clearArray
  } = useContext(InventariosCabFormContext);
  const {
    user,
  } = useContext(AuthContext);
  const [finalUser, setFinalUser] = useState(null);

  useEffect(() => {
    if (user) {
      setFinalUser(user);
    } else {
      const storedUser = localStorage.getItem("paneluserData");
      if (storedUser) {
        setFinalUser(JSON.parse(storedUser));
      }
    }
  }, [user]);

  const navigate = useNavigate(); // Manejo de errores
  const [errors, setErrors] = useState({});
  const { id } = useParams();
  const [form, setForm] = useState({});
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(true);
  // Estado de envío (isSubmitting) para mostrar el estado de carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Estado del detalle
  const [isDetalleFilled, setIsDetalleFilled] = useState(false); // Nuevo estado

  // Estado para controlar la apertura de los diálogos
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // Estados para filtros
  const [searchIDDepo, setSearchIDDepo] = useState();
  const [searchDescDepo, setSearchDescDepo] = useState();

  const nameData = "inventarios";
  const saveData = postInventarioCabData;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // 2 segundos

    return () => clearTimeout(timer);
  }, []);

  const Inputs = useMemo(() => {
    if (!finalUser) return [];
    return getInputs(id, finalUser);
  }, [id, finalUser]);

  useEffect(() => {
    if (finalUser) {
      const initialForm = {};
      Inputs.forEach(input => {
        initialForm[input.name] = input.defaultValue || "";
      });
      setForm(initialForm);
    }
  }, [finalUser, Inputs]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Devuelve solo la parte de la fecha
  };

  useEffect(() => {
    if (report && Object.keys(report).length > 0) {
      setForm({
        ...report,
        sel_fullname: report.aju_sel_id === null
          ? "Página Web"
          : (report?.ajustes_empleado?.sel_lastname?.trim() || report?.ajustes_empleado?.sel_firstname?.trim())
            ? report?.ajustes_empleado?.sel_lastname + ", " + report?.ajustes_empleado?.sel_firstname
            : "Nombre No Disponible",
        createdAt: formatDate(report.createdAt),
        aju_total: report?.aju_total || "0",

      }
      )
      setSearchIDDepo(report.ajustes_deposito?.id);
      setSearchDescDepo(report.ajustes_deposito?.depo_descripcion || "");
    }
  }, [report]);

  useEffect(() => {

    if (form.aof_inventario_desde && form.aof_inventario_hasta) {
      setForm((prevForm) => ({
        ...prevForm,
        aof_inventario_hasta: ""
      }));
    }
  }, [form.aof_inventario_desde]);

  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs, setErrors, form);
  };


  const validateForm = () => {
    let formErrors = {};

    // Validar los campos del formulario
    Inputs.forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) {
          formErrors[name] = error;
        }
      }
    });

    // Verificar si el tamaño de `detalle` es 0
    if (detalleInventarioData.length === 0 && !id) {
      formErrors.detalle = "La inventario no puede estar vacía. Agregue al menos un articulo.";
    }
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };

  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  const handleSendData = () => {
    if (!validateForm()) {
      setErrors((prevErrors) => {
        const errorMessagesArray = Inputs.reduce((acc, { name, label }) => {
          if (prevErrors[name]) {
            const fieldLabel = label || name;
            acc.push(`${fieldLabel}: ${prevErrors[name]}`);
          }
          return acc;
        }, []);

        if (errors.detalle) {
          errorMessagesArray.push(`Articulos: ${errors.detalle}`);
        }

        if (errorMessagesArray.length > 0) {
          openErrorDialog(errorMessagesArray || "por favor verifique os errores");
        }

        return prevErrors;
      });

      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();

    // Eliminar campos no deseados y agregar aju_sel_id
    const { createdAt, sel_fullname, ...restForm } = form;
    const formToSend = {
      ...restForm,
      aju_sel_id: finalUser?.id || null,
      aju_depo_id: searchIDDepo || null,
    };
    try {
      await saveData(formToSend);
      navigate(`/${nameData}`);
    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleCancel = () => {
    navigate(`/${nameData}`);
  };
  if (!finalUser || isLoading) {
    return (
      <div>
        <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
          <h1>Cargando...</h1>
          <CircularProgress />
        </div>
      </div>
    );
  }


  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              {Inputs.map((input) => {
                if (input.name === "aju_depo_id") {

                  return (
                    <>
                      <div className="formInput" key={input.id}>
                        <label>{input.label}</label>
                        <DepositosModal
                          handleChange={(id) => setSearchIDDepo(id)}
                          handleDescChange={(desc) => setSearchDescDepo(desc)}
                          descSelected={searchDescDepo}
                        />
                      </div>
                    </>

                  );
                }
                else {
                  return (
                    <FormField
                      key={input.id}
                      input={input}
                      placeholder={input.placeholder}
                      value={form[input.name] || ""}
                      handleInputChange={(e) => handleChange(e)}
                      error={errors[input.name]}
                    />
                  );
                }


              })}
              {id ? (
                <FormButtons
                  handleCancel={handleCancel}
                  cancelText="Volver"
                  showSaveButton={false}
                />
              ) : (
                <FormButtons
                  isSubmitting={isSubmitting}
                  handleSave={handleSendData}
                  handleCancel={handleCancel}
                  saveText="Guardar"
                  cancelText="Cancelar"
                  isSaveDisabled={!isDetalleFilled}
                />
              )}


            </form>
            <InventariosDetState >
              <DatatableDetalle
                ajuid={id}
                depoid={searchIDDepo}
                arrayDetalle={detalleInventarioData}
                addItem={addItemToArray}
                getItem={getItemFromArrayById}
                updateItem={updateItemFromArray}
                removeItem={removeItemFromArray}
                clearArray={clearArray}
                isCabComplete={searchIDDepo? true : false}
                setIsDetalleFilled={setIsDetalleFilled}
              />
            </InventariosDetState>
            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
